/* eslint-disable jsx-a11y/anchor-is-valid */

import { useAuth } from "../core/Auth";
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export function SSO() {
  const { saveAuth } = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  let navigate = useNavigate();
  useEffect(() => {
    if (token) {
      saveAuth({ token });
    }
  }, [token]);
  return null;
}
